var cpbLoaded = function() {
  if (jQuery('.cpb-panels-container').length > 0) {
    console.log('CPB is loaded');
    customJS.init();
  } else {
    window.requestAnimationFrame(cpbLoaded);
  }   
};

cpbLoaded();

var $root;

var customJS = {
  init: function () {
    this.initGlobals();
    this.setLayout();
    this.addVendorLink();
    this.addCheckoutBtn();
    this.addToCartHandle();
  },
  initGlobals: function() {
    $root = $('#product-builder');
  },
  setLayout: function() {
    var $productCards = $('#product-cards');
    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
    if(width > 999) {
      $('.cpb-preview-container').append($productCards);
    }
    $productCards.css({"opacity":1});
  },
  addVendorLink: function() {
	var $link = $('<a class="product-meta__vendor link link--accented" href="'+$root.data('vendor-url')+'">'+$root.data('vendor-name')+'</a>');
    var $title = $('.cpb-product-title');
    $link.insertAfter( $title );
  },
  addCheckoutBtn: function() {
    $('<button class="is-button is-button--primary js_ckeckout-btn"><span class="is-button__text">Buy it now</span></button>').appendTo('.cpb-product-actions-container');
    
  },
  addToCartHandle: function() {
    var checkoutBtnClicked = false;
    $(document).on('click', '.js_ckeckout-btn', function(){
      checkoutBtnClicked = true;
      $('.cpb-add-to-cart-button').trigger('click');
    })
    document.addEventListener('cpb-add-to-cart', function(event) {
      if(checkoutBtnClicked) {
        window.location.href = '/checkout';
      } else {
        window.location.href = '/cart';
      }
    });
  }
};